// @ vendors
const PropTypes = require('prop-types');
const React = require('react');
import { connect } from 'react-redux';

// @ components
const { AccountsView } = require('./accountsView');
const { NerudaUserAccountsView } = require('routes/nerudaUserAccountsView/nerudaUserAccountsView');


class AccountsViewWrapper extends React.Component {
    render(){
        if (this.props.isNerudaUser || this.props.isAresUser) {
            return <NerudaUserAccountsView {...this.props} />
        } else {
            return <AccountsView {...this.props} isBalanceDrawn />
        }
    }
}

AccountsViewWrapper.propTypes = {
    children: PropTypes.any,
    isNerudaUser: PropTypes.bool.isRequired,
    isAresUser: PropTypes.bool.isRequired,
};

module.exports.constructor = AccountsViewWrapper;
module.exports.AccountsViewWrapper = connect(
    state => ({
        isNerudaUser: state.profile.get('isNerudaUser'),
        isAresUser: state.profile.get('isAresUser')
    })
)(AccountsViewWrapper);